import React from 'react';
import { useSelector } from 'react-redux';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Cookies } from 'react-cookie';
import { imagePath } from '../../../utilities/UrlPaths';

/**
 * This is the more simple version of ActionsCurrent, and does not need to change it's state
 * so it can be a simple class (const) and not a component.
 */
const ActionsPast = ({
  houseRef={houseRef},
  values: { catalogID, catalogRef, invoiceGroupID, invoiceGroupSettingsID, catalogDateTimeUTC }
}) => {
  const user = useSelector(state => state.user);
  const paymentProcessingEnabled = useSelector(state => state.house.paymentProcessingEnabled);
  const { accessInvoices, accessReports } = user;

  // check if is in Days
  let catalogDate = null;
  let diffDays = 0;
  if (typeof (catalogDateTimeUTC) !== 'undefined' && catalogDateTimeUTC !== null) {
    catalogDate = new Date(catalogDateTimeUTC.time);
    diffDays = Math.ceil(Math.abs(catalogDate - Date.now()) / (1000 * 60 * 60 * 24));
  }

  const cookies = new Cookies();
  const isSuperUser = cookies.get('ISSUPERADMIN') === 'true';
  const isOnlineOnly = cookies.get('ISONLINEONLY') === 'true';

  const maxDays = 45;
  let inDays = true;
  if (!isSuperUser) {
    inDays = (diffDays < maxDays);
  }

  return (
    <UncontrolledDropdown className="w-100">
      <DropdownToggle caret color="white">
        Select Action
      </DropdownToggle>
      <DropdownMenu className="actions-dropdown-menu">
        {accessReports && (
        <DropdownItem
          href={`${imagePath}/reports/sessionResults/viewSessionResults/${houseRef}/${catalogRef}`}
          rel="noopener noreferrer"
          name="view-sale-results"
        >
          View sale results
        </DropdownItem>
        )}
        {invoiceGroupID > 0 && accessInvoices && (
        <DropdownItem
          href={`${imagePath}/invoices/InvoiceGroupDetails/${invoiceGroupID}`}
          rel="noopener noreferrer"
          name="manage-invoices"
        >
          Manage invoices&nbsp;<FontAwesomeIcon icon="external-link-alt" />
        </DropdownItem>
        )}
        {((!invoiceGroupSettingsID > 0) && (accessInvoices && paymentProcessingEnabled))
          && (
            <DropdownItem
              href="/ar/invoices"
              rel="noopener noreferrer"
              name="create-invoices"
            >
              Create invoices&nbsp;<FontAwesomeIcon icon="external-link-alt" />
            </DropdownItem>
          )}
        {((invoiceGroupSettingsID > 0 && accessInvoices) && (paymentProcessingEnabled))
          && (
            <DropdownItem
              href={`/ar/invoices/invoiceTemplates/${invoiceGroupSettingsID}`}
              rel="noopener noreferrer"
              name="edit-invoice-template"
            >
              Edit invoice template&nbsp;<FontAwesomeIcon icon="external-link-alt" />
            </DropdownItem>
          )}
        {!isOnlineOnly && accessReports && inDays && (
          <DropdownItem
            href={`${imagePath}/pricesrealized/${catalogID}`}
            rel="noopener noreferrer"
            name="edit-realized-prices"
          >
            Edit realized prices
          </DropdownItem>
        )}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default ActionsPast;
